import { render, staticRenderFns } from "./PinMecanico.vue?vue&type=template&id=3b0e282a"
import script from "./PinMecanico.vue?vue&type=script&lang=js"
export * from "./PinMecanico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports